import ContainedButton from "components/layout/form/containedButton";
import React from "react";
import { MdClose } from "react-icons/md";

import medidor from "assets/images/medidor-2.png";

import { Body, Container, Content, Footer, Header, Img, Style } from "./styles";

const ModalInfo = ({ open, toggleModal }: any): JSX.Element => {
  return (
    <Style show={open} centered animation={false}>
      <Container>
        <Header>
          <div className="wrapper">
            <span>Seu medidor</span>
          </div>
          <MdClose size={24} onClick={toggleModal} />
        </Header>
        <Body>
          <Content>
            <p>Informe os números pretos e vermelhos do medidor</p>
            <Img src={medidor} alt="Medidor de gás" />
            <p>
              Para saber onde fica o quadro de medidores do seu condomínio fale
              com o síndico
            </p>
          </Content>
        </Body>
        <Footer>
          <ContainedButton onClick={toggleModal}>Ok</ContainedButton>
        </Footer>
      </Container>
    </Style>
  );
};

export default ModalInfo;
